import React, { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";
import Select from "react-select";
import "./styles.css";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_AUTH_KEY
);

// Authentication Modal Component
function AuthModal({
  show,
  onClose,
  isSignUp,
  setIsSignUp,
  email,
  setEmail,
  password,
  setPassword,
  username,
  setUsername,
  signIn,
  signUp,
  signInWithGoogle,
  error,
  refreshLeaderboard,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h1 className="auth-title">{isSignUp ? "Sign Up" : "Sign In"}</h1>
        {isSignUp && (
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="auth-input"
          />
        )}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="auth-input"
        />
        <button
          onClick={isSignUp ? signUp : signIn}
          className="auth-button primary-button"
        >
          {isSignUp ? "Sign Up" : "Sign In"}
        </button>
        {/*<button
          onClick={signInWithGoogle}
          className="auth-button google-button"
        >
          Sign In with Google
        </button>*/}
        <button
          onClick={() => setIsSignUp(!isSignUp)}
          className="auth-button secondary-button"
        >
          {isSignUp ? "Switch to Sign In" : "Switch to Sign Up"}
        </button>
        {error && <p className="auth-error">{error}</p>}
        <button onClick={onClose} className="secondary-button">
          Close
        </button>
      </div>
    </div>
  );
}

// Leaderboard Component
function Leaderboard({ leaderboard, refreshLeaderboard, setShowMatchModal }) {
  return (
    <div className="leaderboard-container">
      <h2 className="leaderboard-title">Leaderboard</h2>
      <div className="leaderboard-buttons">
        <button
          onClick={() => setShowMatchModal(true)}
          className="submit-match-button primary-button"
        >
          Submit a Match
        </button>

        <button
          onClick={refreshLeaderboard}
          className="refresh-button primary-button"
        >
          Refresh
        </button>
      </div>
      <table className="leaderboard-table">
        <thead>
          <tr>
            <th className="leaderboard-header">Username</th>
            <th className="leaderboard-header">ELO</th>
            <th className="leaderboard-header">Wins</th>
            <th className="leaderboard-header">Losses</th>
            <th className="leaderboard-header">Ratio</th>
            <th className="leaderboard-header">Played</th>
          </tr>
        </thead>
        <tbody>
          {leaderboard.map((user) => (
            <tr key={user.id} className="leaderboard-row">
              <td className="leaderboard-cell">{user.username}</td>
              <td className="leaderboard-cell">{user.elo}</td>
              <td className="leaderboard-cell">{user.matches_won || 0}</td>
              <td className="leaderboard-cell">{user.matches_lost || 0}</td>
              <td className="leaderboard-cell">
                {user.matches_won / user.matches_lost || 0}
              </td>
              <td className="leaderboard-cell">{user.matches_played || 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Match Submission Modal Component
function MatchSubmissionModal({
  show,
  onClose,
  matchData,
  setMatchData,
  handleMatchSubmit,
  users,
}) {
  if (!show) return null;

  const userOptions = users.map((user) => ({
    value: user.id,
    label: user.username,
  }));

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="match-title">Submit Match</h2>
        <form onSubmit={handleMatchSubmit} className="match-form">
          <div className="player-section">
            <Select
              options={userOptions}
              placeholder="Select Player 1"
              onChange={(option) =>
                setMatchData({ ...matchData, player1: option.value })
              }
              className="match-dropdown"
            />
            <input
              type="number"
              placeholder="Victory Points for Player 1"
              value={matchData.victoryPoints1 || ""}
              onChange={(e) =>
                setMatchData({
                  ...matchData,
                  victoryPoints1: parseInt(e.target.value),
                })
              }
              className="match-input"
            />
          </div>
          <div className="player-section">
            <Select
              options={userOptions}
              placeholder="Select Player 2"
              onChange={(option) =>
                setMatchData({ ...matchData, player2: option.value })
              }
              className="match-dropdown"
            />
            <input
              type="number"
              placeholder="Victory Points for Player 2"
              value={matchData.victoryPoints2 || ""}
              onChange={(e) =>
                setMatchData({
                  ...matchData,
                  victoryPoints2: parseInt(e.target.value),
                })
              }
              className="match-input"
            />
          </div>
          <div className="player-section">
            <Select
              options={userOptions}
              placeholder="Select Player 3"
              onChange={(option) =>
                setMatchData({ ...matchData, player3: option.value })
              }
              className="match-dropdown"
            />
            <input
              type="number"
              placeholder="Victory Points for Player 3"
              value={matchData.victoryPoints3 || ""}
              onChange={(e) =>
                setMatchData({
                  ...matchData,
                  victoryPoints3: parseInt(e.target.value),
                })
              }
              className="match-input"
            />
          </div>
          <div className="player-section">
            <Select
              options={userOptions}
              placeholder="Select Player 4"
              onChange={(option) =>
                setMatchData({ ...matchData, player4: option.value })
              }
              className="match-dropdown"
            />
            <input
              type="number"
              placeholder="Victory Points for Player 4"
              value={matchData.victoryPoints4 || ""}
              onChange={(e) =>
                setMatchData({
                  ...matchData,
                  victoryPoints4: parseInt(e.target.value),
                })
              }
              className="match-input"
            />
          </div>
          <button type="submit" className="match-button primary-button">
            Submit Match
          </button>
        </form>
        <button onClick={onClose} className="secondary-button">
          Close
        </button>
      </div>
    </div>
  );
}

function NavBar({ user, setShowAuthModal, signOut }) {
  return (
    <div className="navbar">
      <h1 className="nav-header">CatanEPi</h1>
      <div className="nav-auth-button">
        {!user ? (
          <button
            onClick={() => setShowAuthModal(true)}
            className="primary-button"
          >
            Sign In / Sign Up
          </button>
        ) : (
          <>
            <button onClick={signOut} className="secondary-button">
              Sign Out
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [matchData, setMatchData] = useState({
    player1: "",
    player2: "",
    player3: "",
    player4: "",
    victoryPoints1: 0,
    victoryPoints2: 0,
    victoryPoints3: 0,
    victoryPoints4: 0,
  });
  const [leaderboard, setLeaderboard] = useState([]);
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [error, setError] = useState(null);
  const [isSignUp, setIsSignUp] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showMatchModal, setShowMatchModal] = useState(false);

  const fetchLeaderboard = async () => {
    const { data } = await supabase
      .from("users")
      .select("*")
      .order("elo", { ascending: false });
    setLeaderboard(data);
    setUsers(data);
  };

  useEffect(() => {
    const fetchUser = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      setUser(user);
    };

    fetchUser();
    fetchLeaderboard();
  }, []);

  const signIn = async () => {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) setError(error.message);
    else {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      setUser(user);
      setShowAuthModal(false);
    }
  };

  const signInWithGoogle = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
    });
    if (error) setError(error.message);
  };

  const signUp = async () => {
    if (!username) {
      setError("Username is required");
      return;
    }

    const { data: existingUsers } = await supabase
      .from("users")
      .select("username")
      .eq("username", username);

    if (existingUsers.length > 0) {
      setError("Username is already taken");
      return;
    }

    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) {
      setError(error.message);
    } else {
      const { user } = data;
      if (user) {
        await supabase.from("users").insert({
          id: user.id,
          username: username,
          elo: 1500,
          matches_played: 0,
        });
      }
      alert(
        "Sign-up successful!"
      );
      setShowAuthModal(false);
      fetchLeaderboard();
    }
  };

  const signOut = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };

  const calculateEloForCatan = (players, victoryPoints) => {
    const K = 8;
    const newElos = players.map((player, index) => {
      const totalDelta = players.reduce((sum, opponent, oppIndex) => {
        if (index === oppIndex) return sum;
        const expected =
          1 / (1 + Math.pow(10, (opponent.elo - player.elo) / 400));
        const result =
          victoryPoints[index] > victoryPoints[oppIndex]
            ? 1
            : victoryPoints[index] === victoryPoints[oppIndex]
            ? 0.5
            : 0;
        return sum + K * (result - expected);
      }, 0);
      return Math.round(player.elo + totalDelta);
    });
    return newElos;
  };

  const handleMatchSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      setShowAuthModal(true);
      return;
    }

    const {
      player1,
      player2,
      player3,
      player4,
      victoryPoints1,
      victoryPoints2,
      victoryPoints3,
      victoryPoints4,
    } = matchData;

    const playerIds = [player1, player2, player3, player4];
    const victoryPoints = [
      victoryPoints1,
      victoryPoints2,
      victoryPoints3,
      victoryPoints4,
    ];

    // Fetch player data
    const { data: players, error } = await supabase
      .from("users")
      .select("id, elo, matches_played, username")
      .in("id", playerIds);

    if (error || players.length !== 4) {
      console.error("Error fetching players or incomplete player data:", error);
      return;
    }

    // Sort the fetched players to match the input order
    const sortedPlayers = playerIds.map((id) =>
      players.find((player) => player.id === id)
    );

    // Ensure victory points are mapped correctly
    const newElos = calculateEloForCatan(sortedPlayers, victoryPoints);

    const matchLog = {
      player_data: sortedPlayers.map((player, index) => ({
        player_id: player.id,
        username: player.username,
        before_elo: player.elo,
        after_elo: newElos[index],
        score: victoryPoints[index],
      })),
      created_at: new Date().toISOString(),
    };

    for (let i = 0; i < sortedPlayers.length; i++) {
      const result = victoryPoints[i] >= 10 ? 1 : 0;
      await supabase
        .from("users")
        .update({
          elo: newElos[i],
          matches_played: (sortedPlayers[i].matches_played || 0) + 1,
          matches_won: sortedPlayers[i].matches_won + result,
          matches_lost: sortedPlayers[i].matches_lost + (result > 0 ? 0 : 1),
        })
        .eq("id", sortedPlayers[i].id);
    }

    // Log the match details in the 'matches' table
    await supabase.from("matches").insert(matchLog);

    setMatchData({
      player1: "",
      player2: "",
      player3: "",
      player4: "",
      victoryPoints1: 0,
      victoryPoints2: 0,
      victoryPoints3: 0,
      victoryPoints4: 0,
    });
    setShowMatchModal(false);
    fetchLeaderboard();
  };

  return (
    <>
      <NavBar
        user={user}
        setShowAuthModal={setShowAuthModal}
        signOut={signOut}
      />
      <div className="app-container">
        <Leaderboard
          leaderboard={leaderboard}
          refreshLeaderboard={fetchLeaderboard}
          setShowMatchModal={setShowMatchModal}
        />
        <AuthModal
          show={showAuthModal}
          onClose={() => setShowAuthModal(false)}
          isSignUp={isSignUp}
          setIsSignUp={setIsSignUp}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          username={username}
          setUsername={setUsername}
          signIn={signIn}
          signInWithGoogle={signInWithGoogle}
          signUp={signUp}
          error={error}
          refreshLeaderboard={fetchLeaderboard}
        />
        <MatchSubmissionModal
          show={showMatchModal}
          onClose={() => setShowMatchModal(false)}
          matchData={matchData}
          setMatchData={setMatchData}
          handleMatchSubmit={handleMatchSubmit}
          users={users}
        />
      </div>
    </>
  );
}

export default App;
